var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { CloudDownload } from '@mui/icons-material';
import styled from 'styled-components';
import DownloadLink from '../organisms/DownloadLink';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  margin: 20px 20px;\n  text-align: center;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"], ["\n  display: inline-flex;\n  margin: 20px 20px;\n  text-align: center;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"])));
var DownloadDocumentList = function (_a) {
    var documents = _a.documents;
    return (React.createElement(React.Fragment, null, documents &&
        documents.map(function (document, index) { return (React.createElement(Wrapper, { key: index },
            React.createElement(DownloadLink, { url: document.path, filename: document.filename },
                React.createElement(CloudDownload, null),
                React.createElement("div", null, document.filename)))); })));
};
export default DownloadDocumentList;
var templateObject_1;
